export default __webpack_public_path__ + "empty-merge-requests-md.ed2fc495.svg";